var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginbanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1281,
    height: 1074,
    viewBox: "0 0 1281 1074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_774",
    "data-name": "Rectangle 774",
    width: 1281,
    height: 1074,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 183.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M1042,233.8h-29.663V167.624l-1.374-.787h-8.845V166.8H950.665v.032h-.041v9.917h.041v6.84h-.041v9.917h.041v6.845h-.041v9.921h.041v.032l-5.448-.032V158.371H887.479v6.575h-.028v9.912h.028v8.7h-.028v9.917h.028v6.845h-.028v9.921h.028v6.332h-.028v9.921h.028v6.332h-.028v9.921h.028V248.7h-.028v6.318h.028v.687H822.4v56.772H798.09v14.3H771.879V302.146H724.722v-66.9h-7.376v-6.662h-1.053v6.662h-36.7v-6.662h-1.071v6.652h-7.971v33.642l-39.608-.183v20.768H597.351V161.1H497.872V298.611H467.49V224.249h-99.5V705.337l679.89-2.591Z",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M368.084,311.852v390.2H283.315v-390.2Z",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 73.9,
    height: 21.756,
    transform: "translate(523.474 161.095)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_776",
    "data-name": "Rectangle 776",
    width: 73.9,
    height: 21.756,
    transform: "translate(523.474 194.586)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_777",
    "data-name": "Rectangle 777",
    width: 73.9,
    height: 21.756,
    transform: "translate(523.474 228.777)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_778",
    "data-name": "Rectangle 778",
    width: 73.9,
    height: 21.756,
    transform: "translate(523.474 263.509)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_779",
    "data-name": "Rectangle 779",
    width: 73.9,
    height: 21.756,
    transform: "translate(523.474 297.023)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_780",
    "data-name": "Rectangle 780",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 158.371)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_781",
    "data-name": "Rectangle 781",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 178.713)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 199.476)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 220.568)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 240.924)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 263.326)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 283.663)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 304.426)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 325.523)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 36.948,
    height: 13.213,
    transform: "translate(887.492 345.874)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 167.038)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_791",
    "data-name": "Rectangle 791",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 187.375)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_792",
    "data-name": "Rectangle 792",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 208.138)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_793",
    "data-name": "Rectangle 793",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 229.235)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_794",
    "data-name": "Rectangle 794",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 249.591)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_795",
    "data-name": "Rectangle 795",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 270.807)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_796",
    "data-name": "Rectangle 796",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 291.149)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_797",
    "data-name": "Rectangle 797",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 311.912)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 333.004)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_799",
    "data-name": "Rectangle 799",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 353.36)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_800",
    "data-name": "Rectangle 800",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 376.705)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_801",
    "data-name": "Rectangle 801",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 397.042)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_802",
    "data-name": "Rectangle 802",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 417.805)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_803",
    "data-name": "Rectangle 803",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 438.902)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_804",
    "data-name": "Rectangle 804",
    width: 36.948,
    height: 13.213,
    transform: "translate(950.738 459.253)",
    fill: "#eef6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 1.831,
    height: 26.962,
    transform: "translate(834.52 229.235)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_806",
    "data-name": "Rectangle 806",
    width: 2.852,
    height: 52.212,
    transform: "translate(865.411 206.082)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_807",
    "data-name": "Rectangle 807",
    width: 1.19,
    height: 9.615,
    transform: "translate(504.478 151.48)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_808",
    "data-name": "Rectangle 808",
    width: 1.186,
    height: 9.615,
    transform: "translate(529.664 151.48)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 1.186,
    height: 9.615,
    transform: "translate(587.407 151.48)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_810",
    "data-name": "Rectangle 810",
    width: 0.916,
    height: 7.422,
    transform: "translate(893.211 150.949)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 0.916,
    height: 7.422,
    transform: "translate(936.554 150.949)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_812",
    "data-name": "Rectangle 812",
    width: 1.186,
    height: 9.615,
    transform: "translate(564.831 151.48)",
    fill: "#dfebfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M984.206,587.539c-10.764,4.084-82.058,11.57-79.124,20.6s52.766,18.14,78.6,6.652c0,0-20.96,76.532-60.224,77.425s-54.126-21.734-78.382-20.74-41.059,9.537-28.276,14.591,52.954-4.121,74.316,10.1c3.136,2.088,6.181,4.047,8.969,5.906,1.685,1.122,3.278,2.207,4.748,3.264H761.985c0-1.154,0-2.248-.028-3.264a84.076,84.076,0,0,0-.636-9.454s-73.927-30.639-47.8-87.159c0,0,22.068-35.418,48.819-47.016,0,0-5.494,80.332,9.5,80.433s-.316-89.961-.316-89.961,68.891-43.765,97.9-44.383c0,0-36.238,82.09-21.66,78.5s56.245-87.269,56.245-87.269,73.254-22.713,90.515,20.246S994.979,583.456,984.206,587.539Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M398.809,24.357c13.1-37.282,76.427-20.667,76.427-20.667s38.687,69.775,51.25,72.293S505.06,9.866,505.06,9.866c24.723-.568,85.13,34.155,85.13,34.155s-9.679,77.375,3.118,76.72S598.395,51.8,598.395,51.8c23.249,8.882,43.4,38.252,43.4,38.252,24.389,47.212-37.5,76.148-37.5,76.148s-2.775,26.884,11.588,59.015h0a92.126,92.126,0,0,1,6.437,15.965l-6.483-.458c-.4-1.776-.861-3.5-1.374-5.16a.037.037,0,0,0,0-.032.341.341,0,0,1,0-.073c-.371-1.035-.916-2.5-1.57-4.3h0c-1.694-4.024-2.82-6.987-3.516-9.116h0c-5.036-12.609-12.417-29.091-17.856-32.836a12.609,12.609,0,0,0,1.607-2.871l-1.607,2.871c-12.82,22.956-68.607,22.837-99.049,14.22s-16.327-16.34,1.374-29.26,52.189-6.7,62.884-11.492-3.937-11.446-24.659-11.377-32.539,19.916-66.057,20.635-54.254-63.754-54.254-63.754c22.434,8.827,64.6-.82,66.767-8.63s-58.91-11.505-68.245-14.582S385.706,61.639,398.809,24.357Z",
    fill: "#cde0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M887.36,66.387c-10.146-28.876-59.185-16.024-59.185-16.024s-29.961,54.025-39.69,55.994,16.592-51.2,16.592-51.2C785.916,54.693,739.148,81.6,739.148,81.6s7.5,59.926-2.413,59.418-3.933-53.4-3.933-53.4c-18,6.868-33.61,29.627-33.61,29.627-18.9,36.568,29.027,58.956,29.027,58.956s2.147,20.822-8.978,45.711h0a71.453,71.453,0,0,0-4.99,12.362l5.036-.366q.458-2.065,1.076-4h0v-.06c.288-.8.7-1.941,1.218-3.328h0c1.314-3.113,2.188-5.407,2.747-7.055h0c3.9-9.761,9.615-22.53,13.84-25.428a9.907,9.907,0,0,1-1.241-2.225l1.241,2.225c9.949,17.778,53.141,17.686,76.715,11.016s12.646-12.659-1.053-22.668-40.5-5.169-48.783-8.868,3.049-8.864,19.1-8.809,25.181,15.42,51.159,15.979,42.03-49.378,42.03-49.378c-17.4,6.836-50.033-.636-51.708-6.68s45.624-8.914,52.853-11.3S897.51,95.262,887.36,66.387Z",
    fill: "#dfebf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M351.084,397.124c9.413-38.82,74.783-28.505,74.783-28.505s45.953,66.286,58.846,67.549-28.226-64.345-28.226-64.345c24.829-3.068,89.082,25.763,89.082,25.763s-1.927,78.8,10.878,76.857-1.854-69.862-1.854-69.862c24.265,6.584,47.514,34.1,47.514,34.1,29.3,45.028-30.011,80.355-30.011,80.355s-.078,27.324,17.618,58.191h0a92.678,92.678,0,0,1,8.09,15.406l-6.57.174q-.87-2.623-1.918-5.036a.041.041,0,0,0,0-.032l-.027-.069c-.458-1-1.163-2.431-2.015-4.166h0c-2.111-3.878-3.544-6.744-4.455-8.813v-.023c-6.341-12.169-15.429-28.006-21.294-31.22a12.787,12.787,0,0,0,1.328-3.049c-.426.971-.865,1.982-1.328,3.049-10.6,24.389-66.707,29.9-98.2,24.3s-18.071-14.788-1.589-29.572,51.914-11.945,62.207-17.856-5.119-11.116-25.955-8.955-30.721,23.318-64.363,27.425-61.021-58.649-61.021-58.649c23.478,6.607,64.894-7.325,66.286-15.42s-60.435-5.631-70.118-7.783S341.667,435.949,351.084,397.124Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M956.031,432.14C973.268,403,927.48,370.611,927.48,370.611s-67.1,13.058-75.672,6.213,55.17-22.375,55.17-22.375c-13.277-16.546-69.317-37.035-69.317-37.035s-45.427,48.989-52.052,40.23,42.437-41.32,42.437-41.32c-18.639-10.361-49.012-7.394-49.012-7.394-44.41,10-29.3,66.533-29.3,66.533S733.622,392.1,704.627,400.38h0a78.4,78.4,0,0,0-14.019,4.578l3.883,3.992q2.079-1.08,4.153-1.932h0l.064-.023c.879-.325,2.138-.787,3.663-1.337h0c3.571-1.108,6.135-2,7.916-2.715h0c11.043-3.64,25.927-7.884,31.389-6.364a10.84,10.84,0,0,1,1-2.637l-1,2.637c-7.985,21.061,22.823,57.6,45.248,72.819s19.719,1.708,18.451-17.013-24.458-37.95-27.219-47.615,9.679-3.722,21.061,9.912,4.862,32.323,22.86,54.712,71.734.458,71.734.458c-18.167-9.871-35.061-42.835-31.133-48.558s40.015,32.31,47.157,36.737S938.789,461.277,956.031,432.14Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_813",
    "data-name": "Rectangle 813",
    width: 343.594,
    height: 599.132,
    rx: 31.847,
    transform: "translate(504.652 104.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M816.4,707.209H536.5a35.885,35.885,0,0,1-35.844-35.844V135.932A35.885,35.885,0,0,1,536.5,100.088H816.4a35.885,35.885,0,0,1,35.844,35.844V671.365A35.885,35.885,0,0,1,816.4,707.209ZM536.5,108.082a27.882,27.882,0,0,0-27.841,27.85V671.365a27.882,27.882,0,0,0,27.85,27.85h279.9a27.882,27.882,0,0,0,27.85-27.85V135.932a27.882,27.882,0,0,0-27.85-27.85Z",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_814",
    "data-name": "Rectangle 814",
    width: 114.954,
    height: 48.787,
    transform: "translate(520.594 172.55)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 114.954,
    height: 48.787,
    transform: "translate(520.594 237.389)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 114.954,
    height: 52.477,
    transform: "translate(716.073 171.886) rotate(90)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1522",
    "data-name": "Ellipse 1522",
    cx: 54.661,
    cy: 54.661,
    r: 54.661,
    transform: "translate(556.894 486.712) rotate(-74.52)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 313.161,
    height: 8.488,
    transform: "translate(520.594 448.645)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 304.673,
    height: 8.488,
    transform: "translate(520.594 299.642)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 290.256,
    height: 8.488,
    transform: "translate(631.469 307.759) rotate(90)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 290.256,
    height: 8.488,
    transform: "translate(833.756 166.639) rotate(90)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_821",
    "data-name": "Rectangle 821",
    width: 425.469,
    height: 8.488,
    transform: "translate(737.953 172.55) rotate(90)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1523",
    "data-name": "Ellipse 1523",
    cx: 36.713,
    cy: 36.713,
    r: 36.713,
    transform: "translate(576.149 472.667) rotate(-68.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 41.988,
    height: 65.201,
    transform: "translate(642.599 318.523)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_823",
    "data-name": "Rectangle 823",
    width: 40.926,
    height: 46.855,
    transform: "translate(520.594 367.589)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_824",
    "data-name": "Rectangle 824",
    width: 82.351,
    height: 40.926,
    transform: "translate(520.594 318.523)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_825",
    "data-name": "Rectangle 825",
    width: 29.366,
    height: 40.532,
    transform: "translate(691.675 318.523)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826",
    "data-name": "Rectangle 826",
    width: 29.366,
    height: 67.733,
    transform: "translate(691.675 367.589)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_827",
    "data-name": "Rectangle 827",
    width: 29.366,
    height: 40.102,
    transform: "translate(691.675 465.168)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    width: 23.698,
    height: 116.799,
    transform: "translate(756.821 318.523)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_829",
    "data-name": "Rectangle 829",
    width: 29.37,
    height: 116.799,
    transform: "translate(788.206 318.523)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_830",
    "data-name": "Rectangle 830",
    width: 41.796,
    height: 116.799,
    transform: "translate(773.417 170.966)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_831",
    "data-name": "Rectangle 831",
    width: 81.436,
    height: 128.575,
    transform: "translate(752.32 469.44)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    "data-name": "Rectangle 832",
    width: 81.047,
    height: 48.627,
    transform: "translate(639.994 549.388)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_833",
    "data-name": "Rectangle 833",
    width: 81.047,
    height: 25.776,
    transform: "translate(639.994 514.441)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_834",
    "data-name": "Rectangle 834",
    width: 72.801,
    height: 83.574,
    transform: "translate(520.594 514.441)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_835",
    "data-name": "Rectangle 835",
    width: 30.652,
    height: 45.033,
    transform: "translate(520.594 461.675)",
    fill: "#dceaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M793.457,667.528a52.061,52.061,0,0,1-44.616-25.378A72.5,72.5,0,0,0,686.5,607.176H520.594V669.19a19.327,19.327,0,0,0,19.527,19.124H817.965a15.629,15.629,0,0,0,15.791-15.466v-5.32Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M771.5,633.648A22.251,22.251,0,1,1,793.753,655.9,22.251,22.251,0,0,1,771.5,633.648Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M780.642,634.674l21.477-10.736-6.616,23.67-5.288-9.052Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_836",
    "data-name": "Rectangle 836",
    width: 121.762,
    height: 5.206,
    transform: "translate(587.201 652.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    width: 55.499,
    height: 5.206,
    transform: "translate(531.701 652.585)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M577.9,637.275l41.553,18.3-42.437,18.95L583.8,655.9Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M716.4,655.167a8.658,8.658,0,1,1,8.653,8.658,8.658,8.658,0,0,1-8.653-8.658Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M535.474,108.306H817.2a27.012,27.012,0,0,1,27.012,27.012v17.4H508.75V135.03a26.72,26.72,0,0,1,26.729-26.724Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M1180.976,346.195c-1.946,5.229-5.316,11.3-8.855,12.819a13.769,13.769,0,0,0-5.686,4.121l-3.237-1.882L1159.329,359s.092-.43.279-1.131a27.607,27.607,0,0,1,.87-2.747,3.745,3.745,0,0,0,.458-3.443,7.994,7.994,0,0,1,.659-6.68c1.241-1.808,2.44-6.245,3.2-6.112,1.808.311-.888,6.41-.114,7.55a1.337,1.337,0,0,0,1.74.6h.027c5.077-2.234,11.235-14.266,13.959-12.641C1181.411,335,1181.8,343.965,1180.976,346.195Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M1163.418,353.479l6.359,4.469a1,1,0,0,0,1.374-.243l16.29-23.18a1,1,0,0,0-.243-1.374l-6.359-4.469a1,1,0,0,0-1.373.243l-16.29,23.153a1,1,0,0,0,.243,1.4Z",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M1169.237,357.572l3.727,2.619a.76.76,0,0,0,1.058-.188l16.564-23.565a.765.765,0,0,0-.183-1.062l-3.727-2.619a.76.76,0,0,0-1.058.188l-16.565,23.565a.769.769,0,0,0,.183,1.062Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M1072.194,320.217s32.355,56.438,44.094,66.844l43.037-32.09a15.7,15.7,0,0,1,8.978,8.186s-26.133,53.251-51.869,55.508-61.849-63.841-61.849-63.841Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M998.971,704.064h-18.7c-2.353-1.277-4.45-4.2-5.109-8.566-.916-6.025-7.664-9.308-9.125-14.234s6.021-11.858,6.021-11.858l1.255-1.612,1.3-1.676,12.407,2.921s.307,2.958.495,6.721c.133,2.715.206,5.856.055,8.607-.366,6.57,1.831,13.644,7.673,14.921C999.557,700.232,999.365,702.782,998.971,704.064Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M1107.47,704.064h-42.753c-2.06-2.509-1.3-11.771-.989-14.793.064-.609.11-.961.11-.961s14.6-11.679,16.6-2.747q.1.417.22.824c2.523,8.365,13.859,12.165,20.4,13.222C1105.314,700.31,1106.889,702.521,1107.47,704.064Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M1099.321,465.416s-2.216,27.658-4.821,60.893c-3.539,45.166-7.783,100.642-8.241,111.149-.728,18.249-3.663,47.441-3.663,47.441s-6.932,6.936-20.8,4.015c0,0-12.362-41.663-15.892-85.767l-.165-2.175c-3.283-44.868-8.392-139.4-8.392-139.4Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M1099.321,465.416s-2.216,27.658-4.821,60.893l-48.563,76.839-.165-2.175c-3.283-44.868-8.392-139.4-8.392-139.4Z",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M1089.2,468.7s-39.956,100.17-66.231,147.245-34.494,60.21-34.494,60.21-15.054-6.021-16.423-10.123c0,0,10.05-90.881,27.644-113.036,9.94-12.517,21.619-50.083,22.169-63.223s3.557-39.136,3.557-39.136Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M1079.253,322.671c-15.617,4.931-42.634-8.369-42.634-8.369s14.4-10.8,13.644-33.271l12.073,9.729,8.2,6.611a97.839,97.839,0,0,1-.916,10.723c-.238,1.795-.531,3.8-.916,5.984a37.406,37.406,0,0,1,10.549,8.594Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M1070.536,297.371a97.839,97.839,0,0,1-.916,10.723c-9.088-1.561-19.394-16.249-19.394-16.249a28.961,28.961,0,0,1,12.124-1.085Z",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M1075.311,297s-25.79,4.285-28.212-11.821-7.38-26.394,8.983-29.81,20.5,2.248,22.613,7.426S1081.959,295.471,1075.311,297Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M1101.047,467.719a2.541,2.541,0,0,1-1.644.627c-5.86-.082-22.961,3.177-37.428,1.689-12.2-1.172-22.993-4.784-34.585-9.981-1.543-.691-5.087-2.582-5-4.3.05-1.882.238-4.615.458-8.058.824-11.963,2.253-32.548.856-56.314-.247-4.423-.38-8.809-.4-13.126-.119-32.186,6.263-60.49,19.087-70.072,1.094-.783,7.82,2.5,14,5.549a25.565,25.565,0,0,0,16.812,2.037l5.393,4.766c6.57,6.1,13.763,14.39,16.89,26.976,2.66,10.713,4.221,30.03,5.082,50.046.389,9.07.705,18.222.787,26.9v.307c.073.861.073,1.8.073,2.665C1101.752,449.735,1101.436,467.4,1101.047,467.719Z",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M1022.857,447.693c.824-11.963,2.253-32.548.856-56.314-.247-4.423-.38-8.809-.4-13.126,5.343-12.961,9.711-22.356,9.711-22.356h13.465S1056.357,423.345,1022.857,447.693Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M953.888,524.111l57.427,8.182a13.763,13.763,0,0,0,15.521-11.652l3.548-24.888a13.762,13.762,0,0,0-11.652-15.521l-57.422-8.2a13.767,13.767,0,0,0-15.525,11.652l-3.548,24.888A13.772,13.772,0,0,0,953.888,524.111Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M1021.973,487.648h0a13.831,13.831,0,0,0-9.514-8.31h0c-.43-.105-.87-.192-1.323-.256l-11.446-1.63.765-5.37a4.555,4.555,0,0,0-3.855-5.142l-2.985-.426-12-1.708-2.166-.311a4.578,4.578,0,0,0-5.164,3.873l-.765,5.37-19.737-2.811a13.818,13.818,0,0,0-15.566,11.693L934.627,507.8a13.818,13.818,0,0,0,11.693,15.567l57.321,8.168a13.4,13.4,0,0,0,2.99.1h0a13.574,13.574,0,0,0,4.473-1.131,13.8,13.8,0,0,0,8.108-10.663l3.59-25.181a13.626,13.626,0,0,0-.829-7.009Zm-44.868-18.9a1.7,1.7,0,0,1,1.41-1.433,1.745,1.745,0,0,1,.513,0l2.55.366,9.45,1.346,5.151.737a1.694,1.694,0,0,1,1.437,1.914l-.764,5.37-20.511-2.926Z",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M997.557,450.009s-3.017,4.02-3.136,5.622c-.81,10.878,4.162,12.385-8.7,18.428,0,0-5.494,2.1-5.59-2.17s3.814-4.336,3.1-10.306c-.824-6.868-.742-6.955,3.782-10.53l2.994-4.949Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M989.888,453.091a44.292,44.292,0,0,0,10.1.563s14.394-44.465,16.244-48.531,42.744-52.129,42.744-52.129L1041.94,310.35s-44.241,73.9-48.732,84.279c-7.422,17.16-10,55.632-10,55.632a18.515,18.515,0,0,0,6.68,2.829Z",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M1047.077,283.631s2.646-.458,2.221-4.089-.421-8.41,2.541-7.522,3.113,3.26,4.331,1.877,1.241-7.225,10.073-7.632,12.4,2.665,16.505.861,4.317-8.012,4.317-8.012a7.07,7.07,0,0,1-2.926,2.921s6.84-9.358-1.081-15.777-16-2.216-20.6-1.937c-10.1.614-16.624,1.218-19.925,7.857S1040.6,277.244,1047.077,283.631Z",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M992.8,454.794s2.9,3.026,3.086,4.285c.591,4.043,1.941,5.792,1.264,6.231-1.406.916-3.269-2.079-4.157-4.766A12.287,12.287,0,0,1,992.8,454.794Z",
    fill: "#ffb27d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M1245.962,704.33v.742c0,1.241-.632,2.257-1.4,2.257H1.4c-.769,0-1.4-1.016-1.4-2.257v-.746c0-1.241.632-2.257,1.4-2.257h1243.16C1245.321,702.072,1245.962,703.089,1245.962,704.33Z",
    fill: "#2e3552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M213.87,179.9c-26.1,0-47.281,22.205-47.281,49.6s47.281,81.271,47.281,81.271,47.281-53.878,47.281-81.271S239.985,179.9,213.87,179.9Zm0,69.848a23.808,23.808,0,1,1,23.808-23.808,23.808,23.808,0,0,1-23.808,23.808Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M298.474,501.361a7.541,7.541,0,1,1,9.381,5.082,7.541,7.541,0,0,1-9.381-5.082Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M230.966,382.954c-.05-.7-.874-8.241-12.4-8.2,0,0,5.686.458,6.758,2.916,0,0-3.969-2.93-7.069-1.831s-4.739,6.675-4.688,8.484,2.01,7.577,4.02,8A6.144,6.144,0,0,0,220,392.23a27.369,27.369,0,0,0-1.442,2.82c-4.24,9.615.842,18.639,4.693,17.471,2.468-.746,3.333,3.484,3.333,3.484l23.492-20.52S240.484,377.41,230.966,382.954Z",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M222.88,506.942s4.327,9.006,9.8,21.477c6.135,13.992,13.7,32.351,18.208,47.276,2.385,7.893,3.915,14.825,3.919,19.646,0,1.657-6.378,8.374-8.218,10.938-11.625,16.175-27.5,37.781-27.5,37.781l-4.331-1.09s6.066-27.012,14.912-40.51c1.74-2.651,6.639-5.879,6.41-6.172h0c-.765-.957-2.669-3.356-5.265-6.771-7.17-9.436-19.614-26.628-27.951-42.62q-.774-1.492-1.506-2.976c-4.4-8.923-7.293-17.288-7.01-23.487Z",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M210.908,644.014l2.985,1.886c1.1.458,2.019.655,3.127,1.168a3.275,3.275,0,0,1,2.047,2.111.193.193,0,0,1,0,.046l12.668,8.017c.609-.252.971-1.5,1.158-2.468a2.133,2.133,0,0,0-.5-1.831c-1.1-1.236-3.525-3.26-4.578-6.991-.581-2.092-3.718-8.7-3.718-8.7h0c-.119-.069-.769-.247-4.418.256-1.882.256-2.395-3.567-2.395-3.567a3.546,3.546,0,0,0-1.277.5,3.727,3.727,0,0,0-1.5,1.772c-.531,1.259-2.486,3-3.878,4.121-.847.682-1.488,1.14-1.488,1.14S208.545,642.073,210.908,644.014Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M216.008,634.408a11.342,11.342,0,0,0,2.188,3.663c1.232,1.03,5.924-.815,5.924-.815h0c-.119-.069-.769-.247-4.418.256-1.882.256-2.395-3.567-2.395-3.567a3.548,3.548,0,0,0-1.3.462Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M210.908,644.014l2.985,1.886c1.1.458,2.019.655,3.127,1.168a3.275,3.275,0,0,1,2.047,2.111.193.193,0,0,1,0,.046l12.668,8.017c.609-.252.971-1.5,1.158-2.468-.165-.586-1.433,1.177-1.831,1.332s-10.4-6.41-10.718-7.229a7.152,7.152,0,0,0-4.414-3.608c-2.449-.842-4.762-4.121-5.315-4.963-.847.682-1.488,1.14-1.488,1.14S208.545,642.073,210.908,644.014Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 6.025,
    height: 111.735,
    transform: "translate(192.503 545.555) rotate(-17.73)",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M223.668,652.287,143.358,645.3,292.3,544.6l-8.52,17.444-122.971,78.73,63.379,5.512Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M234.491,647.576l-5.059-3.269,61.8-98.994,7.193,7.444Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M242.929,633.456l11.3,6.529a2.793,2.793,0,0,1,1.021,3.809h0a2.8,2.8,0,0,1-3.809,1.021l-11.3-6.529a2.8,2.8,0,0,1-1.021-3.809h0A2.8,2.8,0,0,1,242.929,633.456Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M245.172,637.668,230.92,653.441,229.6,652.3l14.257-15.773Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M199.27,583.63a3,3,0,0,1-2.555-.261h0C169.62,567,132.16,573.15,121.3,575.425h0a.957.957,0,0,1-1.158-.916v-2.12a3.264,3.264,0,0,1,2.784-3.232c5.865-.875,19.568-2.747,27.223-2.779h.623c17.146,0,31.957,3.068,44.126,9.157a10.261,10.261,0,0,0,7.985.494l3.338-1.172a3.663,3.663,0,0,1,4.67,2.239h0a2.362,2.362,0,0,1-1.447,3.013Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M174.088,542.383s-1.085-4.936,2.01-5.27,14.39,2.092,17.4,1.758,18.744-2.93,21.518-.252,1.589,5.036-3.933,5.522-12.884,1.424-14.976,3.2S178.859,554.264,174.088,542.383Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1524",
    "data-name": "Ellipse 1524",
    cx: 15.063,
    cy: 15.063,
    r: 15.063,
    transform: "translate(214.332 636.011)",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_839",
    "data-name": "Rectangle 839",
    width: 1.337,
    height: 49.542,
    transform: "translate(130.691 596.078) rotate(-19.74)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M101.251,664.182l-.527-1.227,47.35-20.342,31.124-44.47,1.1.769-31.348,44.781-.174.073Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M129.733,694.573l-1.268-.426c.334-1.007,18.643-49.181,19.422-51.232l.458-1.254,29.5,46.649-1.117.737-28.07-44.41C141.957,662.286,129.99,693.8,129.733,694.573Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 1.337,
    height: 53.315,
    transform: "matrix(0.17, -0.986, 0.986, 0.17, 95.852, 631.448)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_841",
    "data-name": "Rectangle 841",
    width: 48.686,
    height: 1.337,
    transform: "translate(151.21 639.299) rotate(-71.54)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M148.4,643.849l-.2-.1-48.192-24.43.6-1.195,48,24.334,51.658-8.667.22,1.319Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M167.958,692.9c-.284-.838-12.655-31.27-19.577-48.293l-26.747,42.08-1.131-.719L148.642,641.7l.49,1.2c.806,1.982,19.756,48.558,20.095,49.575Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_842",
    "data-name": "Rectangle 842",
    width: 52.445,
    height: 1.337,
    transform: "matrix(0.989, -0.147, 0.147, 0.989, 96.546, 650.187)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_843",
    "data-name": "Rectangle 843",
    width: 1.337,
    height: 43.889,
    transform: "translate(116.545 603.096) rotate(-40.98)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_844",
    "data-name": "Rectangle 844",
    width: 48.695,
    height: 1.337,
    transform: "matrix(0.082, -0.997, 0.997, 0.082, 145.496, 695.288)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_845",
    "data-name": "Rectangle 845",
    width: 1.337,
    height: 55.797,
    transform: "matrix(0.57, -0.822, 0.822, 0.57, 145.784, 641.036)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M110.5,679.1l-.952-.939,38.294-38.628V589.27h1.341v50.811Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M138.638,643.153a9.876,9.876,0,1,1,9.873,9.871A9.876,9.876,0,0,1,138.638,643.153Z",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M148.509,701.051a57.884,57.884,0,1,1,29.3-7.948,57.884,57.884,0,0,1-29.3,7.948Zm0-107.766a49.877,49.877,0,1,0,49.872,49.872,49.878,49.878,0,0,0-49.872-49.872Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M148.953,694.5a51,51,0,1,1,51-51A51,51,0,0,1,148.953,694.5Zm0-99.942A48.943,48.943,0,1,0,197.9,643.5,48.943,48.943,0,0,0,148.953,594.554Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 1.337,
    height: 49.542,
    transform: "translate(319.509 596.078) rotate(-19.74)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M290.068,664.182l-.531-1.227,47.354-20.342,31.124-44.47,1.1.769-31.348,44.781-.174.073Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M318.55,694.573l-1.268-.426c.334-1.007,18.643-49.181,19.422-51.232l.458-1.254,29.5,46.649-1.135.719-28.065-44.41C330.775,662.286,318.807,693.8,318.55,694.573Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_847",
    "data-name": "Rectangle 847",
    width: 1.337,
    height: 53.315,
    transform: "matrix(0.17, -0.986, 0.986, 0.17, 284.679, 631.447)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_848",
    "data-name": "Rectangle 848",
    width: 48.686,
    height: 1.337,
    transform: "translate(340.034 639.303) rotate(-71.54)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M337.221,643.849l-.2-.1-48.192-24.43.6-1.195,48,24.334,51.658-8.667.22,1.319Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M356.775,692.9c-.288-.838-12.655-31.27-19.577-48.293l-26.751,42.08-1.126-.719L337.459,641.7l.49,1.2c.806,1.982,19.756,48.558,20.095,49.575Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_849",
    "data-name": "Rectangle 849",
    width: 52.445,
    height: 1.337,
    transform: "matrix(0.989, -0.147, 0.147, 0.989, 285.359, 650.185)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_850",
    "data-name": "Rectangle 850",
    width: 1.337,
    height: 43.889,
    transform: "translate(305.364 603.101) rotate(-40.98)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_851",
    "data-name": "Rectangle 851",
    width: 48.695,
    height: 1.337,
    transform: "matrix(0.082, -0.997, 0.997, 0.082, 334.307, 695.291)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_852",
    "data-name": "Rectangle 852",
    width: 1.337,
    height: 55.797,
    transform: "matrix(0.57, -0.822, 0.822, 0.57, 334.606, 641.037)",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M299.316,679.1l-.952-.939,38.294-38.628V589.27H338v50.811Z",
    fill: "#afcdfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M337.326,701.051a57.884,57.884,0,1,1,29.3-7.948,57.884,57.884,0,0,1-29.3,7.948Zm0-107.766a49.9,49.9,0,1,0,49.868,49.88,49.9,49.9,0,0,0-49.868-49.88Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M337.77,694.5a51,51,0,1,1,51-51A51,51,0,0,1,337.77,694.5Zm0-99.942A48.943,48.943,0,1,0,386.713,643.5,48.943,48.943,0,0,0,337.77,594.554Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M244.976,437.368s-8.186,4.6-7.22,16.267,11.666,30.048,19.8,34.613c6.446,3.612,25.09,9.257,25.09,9.257l.668-5.064s-15.168-9.9-18.451-13.277C257.823,471.9,251.124,434.548,244.976,437.368Z",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M244.161,463.593a30.035,30.035,0,0,1-1.923,7.046c-.71,1.8-1.534,3.521-2.385,5.306-2.486,5.261-8.342,7.852-8.539,17.966-.064,3.48-2.971,11.322-1.328,17.009,8.095,28.011-44.868,2.541-42.011-4.9,5.7-14.788,13.845-23.35,13.676-35.519a.619.619,0,0,0,0-.092c-.05-.591-.133-2.17-.224-4.262-.22-5.109-.508-13.277-.613-17.4v-.279c-.046-1.767-.1-3.049-.165-3.383,3.937-16.761,13-16.83,16.093-16.78,1.145,0,2.349.1,3.338.179,1.946-1.108,5.306-6.263,7.051-14.738l.705.3,11.881,5.036s-1.1,3.841-1.877,7.513c-.609,2.871-1.016,5.636-.559,6.41.916.339,1.493.554,1.493.554h0C238.992,434.031,246.056,450.266,244.161,463.593Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M242.238,470.658c-.71,1.8-1.534,3.521-2.385,5.306-2.486,5.261-8.342,7.852-8.539,17.966l-.545.05c-21.724,1.7-29.128-23.556-29.128-23.556-.05-.591-.133-2.17-.224-4.262l39.2.064a39.174,39.174,0,0,1,1.616,4.432Z",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M247.755,458.672c-.11.325-.234.65-.366.975-3.768,8.974-7.22,16.482-7.22,16.482l-.316-.174a36.676,36.676,0,0,0-8.758-3.246,71.535,71.535,0,0,0-8.378-1.515,131.17,131.17,0,0,0-21.061-.687c0-.032,0-.059,0-.091-.179-2.033-.687-15.837-.838-21.656v-.279c.865-.691,1.708-1.332,2.486-1.946,2.491-1.969,4.349-3.635,4.391-5.691a15.415,15.415,0,0,0-.151-2.459q-.082-.586-.192-1.167a33.513,33.513,0,0,0-2.637-7.737c4.272-1.918,12.032-1.163,12.032-1.163s0,.43.027,1.131c.078,2.82.375,10.072,1.332,11.391,1.195,1.667,22.15,8.365,23.157,6.007s-2.353-12.87-2.481-13.277h0c7.028,2.454,9.587,4.642,9.587,4.642C244.275,441.063,250.662,449.991,247.755,458.672Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M239.7,419.1s-1.1,3.841-1.877,7.513c-6.9-1.648-9.235-8.74-10-12.563Z",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M241.281,423.043s-16.482-3.164-14.335-13.387,1.447-17.5,12.046-15.914,11.821,5.915,11.94,9.5S245.626,423.62,241.281,423.043Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M251.642,397.459c-1.9-3.6-3.951-3.328-5.219-2.633a11.718,11.718,0,0,0-15.241-.728,19.952,19.952,0,0,1-8.8,10.2s2.605,2.472,9.871,2.147a12.094,12.094,0,0,0,6.41-2.687,39.155,39.155,0,0,1-8.273,6.666c9.029-2.079,14.738-12.819,15.319-13.982.815,1.108,2.381,3.475,2.578,5.517.275,2.775-.458,8.209,1.122,8.351C249.389,410.306,254.48,402.866,251.642,397.459Z",
    fill: "#2c3a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M261.2,497.67l-1.186,5.036s-27.621-3.773-36.627-9.029-22.7-36.169-23.78-49.213c-.06-.691-.1-1.374-.11-1.982-.334-11.258,5.2-13.03,5.2-13.03,2.225-1.021,4.986,2.793,7.911,8.749,6.14,12.49,13,34.42,17.077,40.912C232.815,484.118,261.2,497.67,261.2,497.67Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M212.606,438.22c-7.573-1.786-13.135,4.285-13.135,4.285-.311-11.281,5.224-13.053,5.224-13.053C206.943,428.45,209.69,432.264,212.606,438.22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M248.345,438.2s3.177,6.675,3.832,8.42a7.087,7.087,0,0,0-6.007,4.024S245.923,439.278,248.345,438.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M187.444,507.12s-12.247,19.412,2.884,30.094S256.412,553,253.913,555.07c-7.641,6.336-14.582,16.079-14.216,74.417l3.773,1.95s36.334-79.041,33.88-88.459C275.756,536.738,222.761,502.986,187.444,507.12Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M216.819,547.52S185.947,542.4,182.76,531.5c-2.376-8.14-3.081-11.446,10.91-37.767,0,0,5.847,11.107,36.362,8.534,0,0-.156,1.442-.156,3.393.037,3.232.545,7.829,3.077,9.157.041.037.119.037.156.078,4.015,1.831,10.233,5.526,11.167,5.879C244.316,520.777,225.55,524.367,216.819,547.52Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M234.578,632.312l3.182,1.529c1.145.343,2.083.412,3.242.8a3.374,3.374,0,0,1,2.289,1.831v.046l13.515,6.492c.572-.32.787-1.6.865-2.587a2.138,2.138,0,0,0-.714-1.763c-1.232-1.1-3.878-2.829-5.343-6.41-.824-2.014-4.7-8.214-4.7-8.214h-.027c-.124-.06-.792-.16-4.354.765-1.831.458-2.8-3.264-2.8-3.264a3.549,3.549,0,0,0-1.209.641,3.74,3.74,0,0,0-1.287,1.937c-.385,1.314-2.12,3.264-3.374,4.546-.76.774-1.341,1.3-1.341,1.3S232.005,630.654,234.578,632.312Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M238.534,622.175a10.744,10.744,0,0,0,2.6,3.374c1.346.879,5.792-1.5,5.792-1.5h-.027c-.124-.06-.792-.16-4.354.765-1.831.458-2.8-3.264-2.8-3.264a3.547,3.547,0,0,0-1.209.623Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M234.578,632.312l3.182,1.529c1.145.343,2.083.412,3.242.8a3.374,3.374,0,0,1,2.289,1.831v.046l13.515,6.492c.572-.32.787-1.6.865-2.587-.238-.559-1.291,1.332-1.667,1.534S244.93,636.775,244.522,636a7.161,7.161,0,0,0-4.8-3.072c-2.532-.549-5.206-3.544-5.856-4.313-.76.774-1.341,1.3-1.341,1.3S232.005,630.654,234.578,632.312Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M311.376,568.15a5.814,5.814,0,0,0-5.036-3.663c-24.993-57.422-25.264-57.875-25.639-58.493l-3.612,7.161c-.192-.311,13.648,30.451,23.524,53l-1.41.563,34.416,73.657,5.576-2.289Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M304.119,506.429,260.2,517.454l-.765-8.873,43.92-11.02Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M261.2,497.67s4.121,2.706,7.06,2.587a22.818,22.818,0,0,1,6.634,1.094,6.46,6.46,0,0,1,4.262,5.783s0,1.346-6.149-.545c-1.341-.417-4.578.366-5.663,0s-4.427-3.965-7.325-3.869Z",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M283.315,492.442s4.121,2.706,7.06,2.587a22.864,22.864,0,0,1,6.639,1.094,6.469,6.469,0,0,1,4.263,5.787s-.082,1.9-6.149-.549c-1.667-.673-4.578.366-5.663,0s-5.114-3.448-7.9-4.212Z",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M251.775,514.56a7.545,7.545,0,1,1,9.381,5.082,7.545,7.545,0,0,1-9.381-5.082Z",
    fill: "#415da5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M327.455,643.153a9.876,9.876,0,1,1,9.873,9.871A9.876,9.876,0,0,1,327.455,643.153Z",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M734.931,228.594c-15.232,0-27.58,12.952-27.58,28.931s27.58,47.4,27.58,47.4,27.576-31.426,27.576-47.4S750.159,228.594,734.931,228.594Zm0,40.748a13.882,13.882,0,1,0,0-.009Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M737.93,457.225H668.9l.069-3.068a67.478,67.478,0,0,0-4.986-24.632c-6.749-15.887-19.147-24.224-36.856-24.774-14.39-.458-25.74,3.429-33.72,11.528-14.166,14.376-13.277,37.57-13.277,37.8l.142,3.136H457.042L312.049,346.369H213.641v-5.993H314.077L459.07,451.227H574.157c.215-7.38,2.092-26.042,14.948-39.122,9.2-9.358,22.059-13.845,38.211-13.346,25.314.787,36.957,15.988,42.263,28.606a73.227,73.227,0,0,1,5.32,23.863h57.033V330.949h6Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M722.469,324.25a12.481,12.481,0,1,1,12.479,12.476,12.481,12.481,0,0,1-12.479-12.476Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M734.931,339.057a14.811,14.811,0,1,1,14.806-14.808,14.811,14.811,0,0,1-14.806,14.808Zm0-24.952a10.146,10.146,0,1,0,10.146,10.146A10.146,10.146,0,0,0,734.931,314.1Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1525",
    "data-name": "Ellipse 1525",
    cx: 12.476,
    cy: 12.476,
    r: 12.476,
    transform: "translate(201.394 330.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M213.87,358.236a14.811,14.811,0,1,1,14.811-14.811,14.811,14.811,0,0,1-14.811,14.811Zm0-24.957a10.146,10.146,0,1,0,10.146,10.146A10.146,10.146,0,0,0,213.87,333.279Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M565.43,452.889a12.481,12.481,0,1,1,12.479,12.476,12.481,12.481,0,0,1-12.479-12.476Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M577.911,467.7a14.811,14.811,0,1,1,14.811-14.81A14.811,14.811,0,0,1,577.911,467.7Zm0-24.952a10.153,10.153,0,1,0,0-.014Z",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M555.408,140.492l-4.121,2.944-4.121-2.912a5.036,5.036,0,0,1,8.241-.032Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M551.306,131.207a12.183,12.183,0,0,0-9.985,5.192l2.605,1.831a9.024,9.024,0,0,1,14.715-.055l2.6-1.859A12.215,12.215,0,0,0,551.306,131.207Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M551.306,117.568a25.808,25.808,0,0,0-21.129,10.988l2.605,1.831a22.649,22.649,0,0,1,36.948-.137l2.582-1.863a25.8,25.8,0,0,0-21.006-10.819Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M551.306,125.031a18.456,18.456,0,0,0-15.067,7.783l2.605,1.831a15.306,15.306,0,0,1,24.856-.1l2.587-1.831A18.474,18.474,0,0,0,551.306,125.031Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M1171.961,163.773c-18.35,0-33.225,15.6-33.225,34.851s33.225,57.111,33.225,57.111,33.221-37.863,33.221-57.111S1190.311,163.773,1171.961,163.773Zm0,49.08a16.729,16.729,0,1,1,16.729-16.729,16.729,16.729,0,0,1-16.729,16.729Z",
    fill: "#cde0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M1236.237,555.6l-4.3-1.827,31.916-75.209V377.222l-42.7-1.4V313.908l-40.13-40.13,3.3-3.306,41.5,41.5v59.331l42.7,1.392V479.513l-.183.435Z",
    fill: "#cde0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M1221.609,556.594a12.476,12.476,0,1,1,12.476,12.476,12.476,12.476,0,0,1-12.476-12.476Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M1234.085,571.405A14.816,14.816,0,1,1,1248.9,556.59,14.816,14.816,0,0,1,1234.085,571.405Zm0-24.957a10.146,10.146,0,1,0,10.141,10.143A10.146,10.146,0,0,0,1234.085,546.448Z",
    fill: "#cde0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M1253.708,374.97a12.476,12.476,0,1,1,12.476,12.476,12.476,12.476,0,0,1-12.476-12.476Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M1266.184,389.772A14.816,14.816,0,1,1,1281,374.97a14.816,14.816,0,0,1-14.816,14.8Zm0-24.952a10.141,10.141,0,1,0,10.141,10.15,10.141,10.141,0,0,0-10.141-10.15Z",
    fill: "#cde0fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1526",
    "data-name": "Ellipse 1526",
    cx: 5.27,
    cy: 5.27,
    r: 5.27,
    transform: "translate(1177.4 266.856)",
    fill: "#cde0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M719.942,256.554a14.99,14.99,0,1,1,14.99,14.99A14.99,14.99,0,0,1,719.942,256.554Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginbanner);
export default __webpack_public_path__ + "static/media/loginbanner.5ec529d9959c85f2da2e426d7c1cb236.svg";
export { ForwardRef as ReactComponent };